/**
 * @since 0.14.0
 * @component
 */
export default {
  WHITE: '#ffffff',
  WHITE25: 'rgba(255,255,255,0.25)',
  WHITE50: 'rgba(255,255,255,0.5)',
  TRUE_BLACK: '#000',
  BLACK: '#1b1b1b',
  BLACK08: 'rgba(0,0,0,0.08)',
  BLACK80: 'rgba(0,0,0,0.8)',
  TRANSPARENT: 'rgba(255,255,255,0)',

  GRAY1: '#eff1f4',
  GRAY2: '#e0e4e9',
  GRAY3: '#d3d8de',
  GRAY4: '#bbc2ca',
  GRAY5: '#97a1b0',
  GRAY6: '#7c878e',
  GRAY7: '#bbbbbb',
  GRAY8: '#b1b1b1',
  GRAY9: '#878889',
  GRAY10: '#d6d6d6',
  GRAY11: '#d1cfc7',
  GRAY12: '#E0E0E0',
  GRAY13: '#7f7f7f',
  GRAY14: '#6b6b6b',
  GRAY15: '#d8d8d8',

  SHADOW_GRAY1: 'rgba(33, 33, 33, 0.25)',
  SHADOW_GRAY2: 'rgba(27, 27, 27, 0.5)',
  SHADOW_GRAY3: 'rgba(27, 27, 27, 0.4)',
  SHADOW_GRAY4: 'rgba(27, 27, 27, 0.65)',

  BLUE_GRAY1: '#7da5d3',
  BLUE_GRAY2: '#759bc6',
  BLUE_GRAY3: '#6687ac',
  BLUE_GRAY4: '#4f6986',

  BLUE1: '#e1f5fe',
  BLUE2: '#89aae3',
  BLUE3: '#407bff',
  BLUE4: '#2861ff',
  BLUE5: '#2062d4',
  BLUE6: '#003da5',
  BLUE7: '#002688',
  BLUE8: '#001770',
  BLUE9: '#000548',
  BLUE10: '#2962ff',
  BLUE11: '#00a5ee',
  BLUE12: '#e3f2fd',
  BLUE13: '#9bb1d8',
  BLUE14: '#cae5fb',
  BLUE15: '#b4d9f9',

  RED1: '#fb4746',
  RED2: '#fa3736',
  RED3: '#fa2625',
  RED4: '#fa1614',
  RED5: '#f70706',
  RED6: '#e70605',
  RED7: '#d60605',
  RED8: '#c50605',
  RED9: '#b50504',
  RED10: '#ff2929',
  RED11: '#fa321a',
  RED12: '#ff585d',
  RED13: '#ba141a',
  RED14: '#e71313',
  RED15: '#fdeded',
  RED16: 'rgba(231, 19, 19, 0.15)',

  TEAL1: '#eaf5e1',
  TEAL2: '#b9dcd2',
  TEAL3: '#99d6ea',
  TEAL4: '#7bc2d9',
  TEAL5: '#00a99d',
  TEAL6: '#d2e6f5',
  TEAL7: '#3f92a6',

  PURPLE1: '#c3d7ee',
  PURPLE2: '#b6b8dc',
  PURPLE3: '#ebe8f9',

  GREEN1: '#f6fee1',
  GREEN2: '#e6fa5e',
  GREEN3: '#d9ec5a',
  GREEN4: '#cddc3a',
  GREEN5: '#c0ca33',
  GREEN6: '#acbc00',
  GREEN7: '#4ba15e',
  GREEN8: '#bce194',
  GREEN9: '#7cb342',
  GREEN10: '#318500',
  GREEN11: '#eff6eb',
  GREEN12: '#edf7df',
  GREEN13: '#ecf6df',
  GREEN14: '#64A33F',

  YELLOW1: '#edd21d',
  YELLOW2: '#f8f5d8',
  YELLOW3: '#ffface',
  YELLOW4: '#E2C300',
  YELLOW5: '#FFFCE6',

  ORANGE1: '#f9a825',
  ORANGE2: '#ef6d19',
  ORANGE3: '#fef4ed',
} as const;
